export default "__VITE_ASSET__Kea4gahJ__"